import {Clients} from '@/api/clients'

import ClientApi from '@/api/client'

import {
  CLIENT_SELF_UPDATE,
  UPDATE_CLIENT
} from './types/index'

const state = {
  userProfile: {},
  userPortfolio: {},
  userPortfolioLoaded: false,
  clientDeals: null,
  clientDealsLoaded: false,
}

const getters = {
  profitability: state => {
    let userProfile = state.userProfile
    let profitability = ((userProfile.portfolio_cost - userProfile.portfolio_buying_sum) * (userProfile.income_percent / 100) + userProfile.deals_income) / userProfile.contract_sum[0]
    return profitability * 100
  },
  balance: state => {
    let userProfile = state.userProfile
    return userProfile.balance
    // return userProfile.contract_sum[0] + userProfile.deals_income - userProfile.contract_sum[1] - userProfile.portfolio_buying_sum - userProfile.contract_sum[2] + userProfile.contract_sum[3]
  },
  open_symbols: state => {
    let userDeals = state.clientDeals
    let symbols = userDeals.open.map(function(item){
      return item.symbol.symbol
    })
    return symbols
  },
  closed_symbols: state => {
    let userDeals = state.clientDeals
    let symbols = userDeals.closed.map(function(item){
      return item.symbol.symbol
    })
    return symbols
  },
  portfolioForChart: state => {
    const portfolio_data = state.userPortfolio

    let total_sum = 0
    const sectors_list = Object.keys(portfolio_data)
    const values_list = Object.values(portfolio_data)

    values_list.map(x => total_sum += x)

    return {
      'sectors': sectors_list,
      'values': values_list,
      'total': total_sum
    }
  }
}

const mutations = {
  // [GET_CLIENT_TAX_PAYMENTS] (state, payload) {
  //   state.taxPaymentsArr = payload
  // },
  [CLIENT_SELF_UPDATE] (state, payload) {
    state.auth.user.member = payload
  },
  setUserProfile (state, payload) {
    state.userProfile = payload
  },
  setUserPortfolio(state, payload) {
    state.userPortfolio = payload
    state.userPortfolioLoaded = true
  },
  setClientDeals(state, payload) {
    state.clientDeals = payload
    state.clientDealsLoaded = true
  }
}

const actions = {
  [CLIENT_SELF_UPDATE] ({commit}, {client, userId}) {
    return Clients[UPDATE_CLIENT](client, userId)
      .then((result) => {
        commit(CLIENT_SELF_UPDATE, result)
      })
  },
  getClientProfile ({commit}, clientId) {
    return ClientApi.getClientProfile(clientId)
        .then(response => {
          commit('setUserProfile', response)
        })
  },
  getClientPortfolio ({commit}, clientId) {
    return ClientApi.getClientPortfolio(clientId)
        .then(response => {
          commit('setUserPortfolio', response)
        })
  },
  getClientDeals ({commit}, clientId) {
    return ClientApi.getClientDeals(clientId)
        .then(response => {
          commit('setClientDeals', response)
        })
  },
  // getClientProfitability({commit}, clientId, dates) {
  //   return ClientApi.getClientProfitability(clientId, dates)
  //       .then(response => {
  //         commit('setProfitability')
  //       })
  // },
  // getUserInfo ({commit}) {
  //   HTTP.get('/securities/client')
  //     .then(r => r.data)
  //     .then(securities => {
  //       commit('SET_USER_SECURITIES', securities)
  //     })
  // },

}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
